
import { api, getAuthHeaders } from '@/config/api';
import { IProduct, ISubprocessFieldValidation, IPrerequisiteValidation } from './types';

const BASE_URL = '/products';

export const productService = {
  getAll: () => api.get<IProduct[]>(BASE_URL,{
    headers:getAuthHeaders()
  }),
  getById: (id: string) => api.get<IProduct>(`${BASE_URL}/${id}`,{
    headers:getAuthHeaders()
  }),
  create: (product: Partial<IProduct>) => api.post<IProduct>(BASE_URL, product,{
    headers:getAuthHeaders()
  }),
  update: (id: string, product: Partial<IProduct>) => api.put<IProduct>(`${BASE_URL}/${id}`, product,{
    headers:getAuthHeaders()
  }),
  delete: (id: string) => api.delete(`${BASE_URL}/${id}`),
  
  // New endpoints for subprocess field validation
  validateSubprocessField: (productId: string, fieldId: string) => 
    api.post<ISubprocessFieldValidation>(`${BASE_URL}/${productId}/validate-subprocess-field/${fieldId}`,{
    headers:getAuthHeaders()
  }),
  
  // Validate activity prerequisites
  validatePrerequisites: (productId: string, activityId: string) =>
    api.post<IPrerequisiteValidation>(`${BASE_URL}/${productId}/validate-prerequisites/${activityId}`,{
    headers:getAuthHeaders()
  }),
    
  // Get available subprocess fields for a phase
  getSubprocessFields: (productId: string, phaseId: string) =>
    api.get<string[]>(`${BASE_URL}/${productId}/phases/${phaseId}/subprocess-fields`,{
    headers:getAuthHeaders()
  })
}; 